// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CategoryAccordionItem } from './atoms';
import {
  setUiSetting,
  getUiSetting,
} from '../../../store/uiStore';

const UI_STORE_KEY = 'faqAccordion';

type StateProps = {|
  openQuestion: ?any,
|};

type DispatchProps = {|
  setOpenQuestion: Function,
|};

type OwnProps = {|
  questions: Array<{
    question: string,
    answer: string,
    id: number | string,
  }>,
|};


type Props = {|
  ...StateProps,
  ...DispatchProps,
  ...OwnProps,
|};

class CategoryAccordion extends Component<Props> {
  toggleItem = (id: number | string) => {
    const { setOpenQuestion, openQuestion } = this.props;
    setOpenQuestion(id === openQuestion ? null : id);
  }

  render() {
    const { questions, openQuestion } = this.props;
    return (
      <>
        {questions.map(({ question, id, answer }) => (
          <CategoryAccordionItem
            key={id}
            question={question}
            answer={answer}
            toggleItem={() => this.toggleItem(id)}
            isVisible={id === openQuestion}
          />
        ))}
      </>
    );
  }
}

const mapStateToProps = (state): StateProps => ({
  openQuestion: getUiSetting(state, UI_STORE_KEY),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  setOpenQuestion: (value: string) => dispatch(setUiSetting(UI_STORE_KEY, value)),
});

export default connect<Props, OwnProps, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(CategoryAccordion);
